import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Profile</Typography>
      <p>Use this page to maintain your name, email address and password.</p>
      <p>If you signed up with Apple, Google or LinkedIn, then you do not need
        a password to access Studio. However, you can add one if you wish. You can 
        then login without Apple, Google or LinkedIn.
      </p>

      <p>This can be essential if you use Smartix Scan on a shared device where you cannot 
        use them. You can then fallback to password login.</p>

      <p>We do not require you to use any combination of uppwercase, lowercase, number or
        <i>special</i> characters. Just ensure your password is sufficiently long to reach
        the <b>good</b>, or <b>strong</b> setting on the meter.
      </p>
    </div>

  )
}

export default HelpText
